import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const PlusIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="10.203" height="10.203" viewBox="0 0 10.203 10.203">
		<path
			d="M9.456-8.07H6.939v-2.4a1.286,1.286,0,0,0-1.3-1.3,1.282,1.282,0,0,0-1.278,1.3v2.4H1.847a1.286,1.286,0,0,0-1.3,1.3A1.282,1.282,0,0,0,1.847-5.5H4.364v2.632a1.282,1.282,0,0,0,1.278,1.3,1.286,1.286,0,0,0,1.3-1.3V-5.5H9.456a1.282,1.282,0,0,0,1.3-1.278A1.286,1.286,0,0,0,9.456-8.07Z"
			transform="translate(-0.55 11.77)"
			fill="#155f61"
		/>
	</svg>
);
